import { render, staticRenderFns } from "./safety.vue?vue&type=template&id=50851b6a&scoped=true"
import script from "./safety.vue?vue&type=script&lang=js"
export * from "./safety.vue?vue&type=script&lang=js"
import style0 from "./safety.vue?vue&type=style&index=0&id=50851b6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50851b6a",
  null
  
)

export default component.exports